import s from "./contact-channels95.js";
import r from "./contact-channels96.js";
import i from "./contact-channels97.js";
import t from "./contact-channels98.js";
import v from "./contact-channels99.js";
import e from "./contact-channels100.js";
import a from "./contact-channels101.js";
import n from "./contact-channels102.js";
import m from "./contact-channels103.js";
import p from "./contact-channels104.js";
import _ from "./contact-channels105.js";
import o from "./contact-channels106.js";
import f from "./contact-channels107.js";
import C from "./contact-channels108.js";
const S = {
  da_dk: {
    vistaprint: s
  },
  en_us: {
    vistaprint: r
  },
  en_ca: {
    vistaprint: r
  },
  de_de: {
    vistaprint: i
  },
  de_ch: {
    vistaprint: i
  },
  de_at: {
    vistaprint: i
  },
  en_au: {
    vistaprint: t
  },
  en_gb: {
    vistaprint: t
  },
  en_ie: {
    vistaprint: t
  },
  en_in: {
    vistaprint: t
  },
  en_nz: {
    vistaprint: t
  },
  en_sg: {
    vistaprint: t
  },
  es_es: {
    vistaprint: v
  },
  es_us: {
    vistaprint: e
  },
  fi_fi: {
    vistaprint: a
  },
  fr_be: {
    vistaprint: n
  },
  fr_ca: {
    vistaprint: m
  },
  fr_ch: {
    vistaprint: n
  },
  fr_fr: {
    vistaprint: n
  },
  it_ch: {
    vistaprint: p
  },
  it_it: {
    vistaprint: p
  },
  nb_no: {
    vistaprint: _
  },
  nl_be: {
    vistaprint: o
  },
  nl_nl: {
    vistaprint: o
  },
  pt_pt: {
    vistaprint: f
  },
  sv_se: {
    vistaprint: C
  }
};
export {
  S as default
};
//# sourceMappingURL=contact-channels64.js.map
